module.exports = __webpack_public_path__ + "static/media/door_lighter.666892ef.svg";